import React, { useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

export default function HeaderOnlineShopSearch() {
  const t = useTranslations();
  const pathname = usePathname();
  const [query, setQuery] = useState<string>('');

  const redirectURL = '/city/online-shop';

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const handleSearch = () => {
    if (query.trim()) {
      window.location.href = `${redirectURL}?search=${encodeURIComponent(
        query.trim()
      )}`;
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch();
  };

  if (pathname.endsWith(redirectURL)) {
    return;
  }

  return (
    <form
      role="search"
      aria-label="Search online shop"
      onSubmit={handleSubmit}
      className="max-w-md xl:ml-3 xl:w-full"
    >
      <div className="relative">
        <button
          type="button"
          onClick={handleSearch}
          className="absolute inset-y-0 start-0 flex items-center pl-3 focus:outline-none"
          aria-label="Trigger search"
        >
          <MagnifyingGlassIcon className="h-6 w-6 text-gray-400" />
        </button>

        <input
          type="search"
          name="keyword"
          value={query}
          onChange={handleInputChange}
          placeholder={t('search')}
          aria-label="Search online shop"
          className="w-full rounded-full border-0 bg-white py-3 pl-10 pr-4 shadow-[0px_14px_70px_rgba(0,0,0,0.1)] outline-0 focus:border-0 focus:ring-0"
        />
      </div>
    </form>
  );
}
